<template lang="pug">
  b-row.mb-5
    b-col
      router-view(@profile-changed='reloadAccountsPanel')
</template>

<script>
export default {
  name: 'manager-accounts-profile',
  methods: {
    reloadAccountsPanel() {
      this.$parent.$refs.accountsPanel.panelReload()
    },
  },
}
</script>
